/**
 *  Component: Installation Section
 */
import React from 'react';

import { StyledTypography } from 'styles/common';

import { Download1Icon } from 'constants/icons';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const Item = ({ children, isTopItem = false }) => (
  <StyledTypography bottomGutter={2} topGutter={isTopItem ? 2 : 0}>
    {children}
  </StyledTypography>
);

const InstallationSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <Download1Icon size="fixed16px" />
      </Icon>
      Installation Steps
    </FormHeading>
    <Separator />
    <BodyContainer>
      <Item isTopItem>1. Click the "Install" button.</Item>
      <Item>2. Choose the appropriate HRIS that you wish to connect to.</Item>
      <Item>3. Login and grant permissions.</Item>
      <Item>
        4. To ensure a successful integration, please <strong>remember</strong> to <strong>click</strong> the{' '}
        <strong>"Close window"</strong> button once integration is complete.
      </Item>
    </BodyContainer>
  </FormContainer>
);

export default InstallationSection;
